export default __webpack_public_path__ + "static/media/shop-cart-price.323dfc81.jpg";